var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 360,
    height: 360,
    rx: 58,
    fill: "#1DABF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.595 168.466V327.6C400.595 347.56 382.088 363.849 358.679 363.849C335.271 363.849 316.426 347.56 316.426 327.642C316.426 307.724 335.482 291.477 358.679 291.477C368.616 291.404 378.309 294.542 386.313 300.423V234.93L254.102 267.508V390.097C254.102 410.057 235.214 426.262 211.848 426.262C188.482 426.262 169.595 410.015 169.595 390.097C169.595 370.179 188.651 353.932 211.848 353.932C221.798 353.859 231.505 356.997 239.524 362.878V204.588C239.524 202.976 240.065 201.41 241.061 200.14C242.057 198.87 243.45 197.97 245.017 197.583L391.637 161.461C392.701 161.207 393.808 161.196 394.876 161.429C395.945 161.661 396.947 162.132 397.808 162.805C398.669 163.479 399.367 164.337 399.849 165.317C400.332 166.297 400.587 167.374 400.595 168.466Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.609 505.404C492.746 505.404 519.609 478.541 519.609 445.404C519.609 412.267 492.746 385.404 459.609 385.404C426.472 385.404 399.609 412.267 399.609 445.404C399.609 478.541 426.472 505.404 459.609 505.404Z",
    fill: "white",
    stroke: "#1DABF2",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.51 482.393H473.71V443.938H491.655L459.61 402.279L427.564 443.938H445.51V482.393Z",
    fill: "#1DABF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.ed74b3ee29bca8b4c27403addcafa89f.svg";
export { ForwardRef as ReactComponent };